import { render } from "./footerView.vue?vue&type=template&id=1824acde&scoped=true"
import script from "./footerView.vue?vue&type=script&lang=js"
export * from "./footerView.vue?vue&type=script&lang=js"

import "./footerView.vue?vue&type=style&index=0&id=1824acde&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1824acde"]])

export default __exports__